module.exports = __webpack_public_path__ + "static/html_3-09bd54a3ca48b385cbe31c28716511ca.jpg";